import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';

const FONT_SIZE = 1;

const nameColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const backgroundColor = theme('mode', {
  light: (props) => props.theme.colors.white,
  dark: (props) => props.theme.colors.greyDarker,
});

const backgroundColorHover = theme('mode', {
  light: (props) => props.theme.colors.lightBlue2,
  dark: (props) => props.theme.colors.cyanDarker,
});

const Name = styled(Box)`
  flex: 1 0;
  line-height: ${(props) => props.lineHeight};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${nameColor};
  min-width: 75px;
  min-height: 30px;
`;

const ItemContainer = styled(Name)`
  line-height: ${(props) => props.lineHeight};
  background-color: ${backgroundColor};
  transition: ${(props) => props.theme.animation.quick};
  &:hover {
    background-color: ${backgroundColorHover};
  }
`;

const TextBox = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

function DropdownItem(props) {
  const {
    item, handleClick, lineHeight,
  } = props;
  return (
    <ItemContainer
      p={2}
      fontSize={FONT_SIZE}
      lineHeight={lineHeight}
      onClick={handleClick}
      title={item}
      data-testid={`feature-toggle-dropdown-item-${item}`}
    >
      <TextBox>
        {item}
      </TextBox>
    </ItemContainer>
  );
}

DropdownItem.defaultProps = {};

DropdownItem.propTypes = {
  handleClick: PropTypes.func.isRequired,
  item: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.object,
  ]).isRequired,
  lineHeight: PropTypes.string.isRequired,
};

export default DropdownItem;
